module.exports = __webpack_public_path__ + "components/page-footer/static/meteo365__logo--white-77eb2c6ada0afc40dc316b22e1df739d.png";